import { Component } from "@angular/core";

/**
 * ClassicReportingComponent — the Clio Classic "Reporting" view (ClioAdmin #71,
 * Phase 4).
 *
 * Reuses the `MsxReportsComponent` (`<app-msx-reports>`) surface, which owns the
 * working report-type navigation (Aurora-backed via clio-server /msx/* + /reporting/*).
 * The deferred **Undeliverable Emails** report (per the defer decision) is shown as a
 * single non-clickable "coming soon" chip rather than a dead competing strip.
 *
 * B2 applies the Clio facelift to the `.classic-*` hooks + the embedded nav.
 * Follow-up (#71): a fully V1-faithful report-type strip wired to /reporting/*.
 */
@Component({
    selector: "app-classic-reporting",
    templateUrl: "./classic-reporting.component.html",
    styleUrls: ["./classic-reporting.component.scss"],
})
export class ClassicReportingComponent {}
